<template>
    <section class="tags_list">
        <h2>{{ sectionName }}</h2>
        <div class="right" v-if="searchField">
            <div class="field_left">
                <p class="field">
                    <input
                        v-model="search"
                        class="search"
                        id="vyhledavani2"
                        name="vyhledavani2"
                        size="30"
                        type="text"
                        :placeholder="$gettext('Vyhledávání')"
                    />
                    <a
                        v-if="search.length > 0"
                        id="vyhledavani_delete2"
                        class="clearable_btn"
                        style="display:inline"
                        :title="$gettext('Vymazat text')"
                        @click.prevent="clearSearch"
                    >{{$gettext('Vymazat')}}</a>
                </p>
            </div>
        </div>
        <ul>
            <li v-for="value in checkedValues" :key="value._id">
                <input
                    :id="'v' + value._id"
                    :name="'v' + value._id"
                    type="checkbox"
                    :value="value._id"
                    v-model="value.checked"
                    @change="onCheckbox()"
                />
                <label :for="'v' + value._id" >
                    {{ value.name }}
                </label>
            </li>
        </ul>
        <ul>
            <li v-for="value in uncheckedValues" :key="value._id">
                <template v-if="!search || value.name.toLowerCase().includes(search.toLowerCase())">
                    <input
                        :id="'v' + value._id"
                        :name="'v' + value._id"
                        type="checkbox"
                        :value="value._id"
                        v-model="value.checked"
                        @change="onCheckbox()"
                    />
                    <label :for="'v' + value._id" >
                        {{ value.name }}
                    </label>
                </template>
            </li>
        </ul>
    </section>
</template>

<script>
import AppBooleanLiteralVue from '../AppBooleanLiteral.vue'


export default {
  components: {  },
  name: 'show-checkbox-list',
    props: {
        sectionName: {
            type: String,
            required: true
        },
        searchField: {
            type: Boolean,
            default: false
        },
        values: {
            type: Array,
            required: true
        }
  },
  created() {
      if (this.values.length > 0) {
          this.localValues = [...this.values]
      }
  },
  data() {
    return {
        localValues: [],
        search: ''
    }
  },
  computed: {
      checkedValues() {
          return this.localValues.filter(value => {
              return value.checked
          })
      },
      uncheckedValues() {
          return this.localValues.filter(value => {
              return !value.checked
          })
      }
  },
  methods: {
      onCheckbox() {
          this.localValues = [...this.localValues]
          this.$emit('change', this.localValues)
      },
      clearSearch() {
          this.search = ''
      }
  },
  watch: {
      values() {
          this.localValues = [...this.values]
      }
  }
}
</script>
